export function cloudinaryMediaAssetToFileTypeInfo(data) {
  const asset = typeof data['consumerId'] === 'number' ? data.asset : data;
  const fileNameAndPath = asset.type === 'raw' ? asset.providerData.publicId : asset.providerData.publicId + '.' + asset.providerData.originalExtension;
  const filename = fileNameAndPath.substring(fileNameAndPath.lastIndexOf('/') + 1);
  return {
    extension: asset.providerData.originalExtension,
    filename
  };
}